export default __webpack_public_path__ + "locales/sk/SocialAuthWelcomeDialog.json?hash=682a17f5b07329b3eb9eeda95cbc31f6";